import { React, models, kea, history, resources, selectores, componentToRx, Route, match, withRouter } from "app/main/std";
import { UsuarioForm } from "./form";
import { observeResource } from "kea-resource";

type Entity = models.Usuario;
const resource = resources.Usuario;
const observable = observeResource(resources.Usuario.query, {});

interface Props {
    match: match<{ id: string }>
}
interface State {
    value: Promise<Entity> | Entity;
}
class UsuarioEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { value: this.getValue() };
    }
    get id(): number | "new" {
        const id = this.props.match.params.id;
        return id == "new" ? id : Number.parseInt(id);
    }
    async getValue() {
        if (this.id == "new") {
            return {
                Habilitado: true
            } as Entity;
        } else {
            return await resource.get(this.id);
        }
    }

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));
    onGuardar = async () => {
        const id = this.id;
        const func = id == "new" ? resource.add : resource.update;
        const value = await this.state.value;
        await func(value);
        history.go("/catalogos/Usuario");
    }

    render() {
        const props = this.props;
        const params = props.match!.params.id;
        return (
            <UsuarioForm
                value={this.state.value}
                onChange={this.onChange}
                onGuardar={this.onGuardar}
                nuevo={this.id == "new"}
            />)
    }
}

export const UsuarioEdit = withRouter(UsuarioEditComp);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarios/edit/edit.tsx